import React from 'react';

import IngkaList, { ListProps } from '@ingka/list';

const List = (props: ListProps) => (
    <IngkaList prefix="list-ingka-" {...props} />
);

export default List;
